// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__GMNkT","title":"index_title__WaNUH"};